import React, { Suspense, lazy } from "react";
import { CircularProgress, ThemeProvider, Box } from "@mui/material";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import ProtectedRoute from "./auth/ProtectedRoute";
import LanguageProtector from "./components/LanguageProtector";
import theme from "./theme";

const Home = lazy(() => import("./pages/Home"));
const Result = lazy(() => import("./pages/Result"));
const ItalyLogin = lazy(() => import("./components/ItalyLogin"));

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <LanguageProtector>
          <Router>
            <Suspense
              fallback={
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                  }}
                >
                  <CircularProgress size={60} />
                </Box>
              }
            >
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login-italy" element={<ItalyLogin />} />
                <Route 
                  path="/result/:city" 
                  element={
                    <ProtectedRoute>
                      <Result />
                    </ProtectedRoute>
                  } 
                />
              </Routes>
            </Suspense>
          </Router>
        </LanguageProtector>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;